// extracted by mini-css-extract-plugin
module.exports = {"newscontent-box":"dc","newscontentBox":"dc"};